<template>
  <react-button 
    v-bind:isReacted="statement.meta.isConsidered" 
    v-bind:name="'Consider'" 
    v-bind:icon="'question-circle'"
    @toggleOn="considerStatement(); $emit('react')" 
    @toggleOff="unconsiderStatement(); $emit('react')"
  />
</template>

<script>
  import ConsiderButton from "./ConsiderButton.ts";

  export default ConsiderButton;
</script>
